import { MenuItem } from "@mui/material";
import { AdditionalCost } from "generated/graphql";
import { Link } from "react-router-dom";

export default function Update({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: AdditionalCost["id"];
}) {
  return (
    <MenuItem component={Link} onClick={closeMenu} to={`/organization/additional-costs/${id}`}>
      Update
    </MenuItem>
  );
}
